import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import QRCode from 'qrcode';

import { API_URL } from '@App/app.constants';
import { getHeaders } from '@utils/QueryClient/query-client.utils';

function useAdaptationStories() {
  return useQuery({
    queryKey: ['stories'],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/api/adaptation-stories`);
      return data;
    },
  });
}

function usePublishedAdaptationStories(options) {
  return useQuery({
    queryKey: ['stories-published'],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/api/adaptation-stories?status=published`);
      for (let i = 0; i < data.length; i += 1) {
        data[i].category = 'Story';
      }
      return data;
    },
    ...options,
  });
}

function usePublishedAdaptationPlans(options) {
  return useQuery({
    queryKey: ['plans-published'],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/api/adaptation-plans?status=published`);
      for (let i = 0; i < data.length; i += 1) {
        data[i].category = 'Plan';
      }
      return data;
    },
    ...options,
  });
}

function useAdaptationPlans() {
  return useQuery({
    queryKey: ['plans'],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/api/adaptation-plans`);
      return data;
    },
  });
}

function useUsers() {
  return useQuery({
    queryKey: ['users'],
    queryFn: async () => {
      const { data } = await axios.get(`${API_URL}/api/users`, {
        headers: getHeaders(),
      });
      return data;
    },
  });
}

function useQRCode(text) {
  return useQuery({
    queryKey: ['qrcode', text],
    queryFn: () => QRCode.toDataURL(text),
    enabled: !!text,
    networkMode: 'always',
  });
}

export {
  useAdaptationPlans,
  useAdaptationStories,
  useUsers,
  usePublishedAdaptationPlans,
  usePublishedAdaptationStories,
  useQRCode,
};